import { render, staticRenderFns } from "./pointOfSalesOverview.vue?vue&type=template&id=96db65d8&"
import script from "./pointOfSalesOverview.vue?vue&type=script&lang=js&"
export * from "./pointOfSalesOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports